/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AmsVidMappingResponse
 */
export interface AmsVidMappingResponse {
    /**
     * 
     * @type {string}
     * @memberof AmsVidMappingResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AmsVidMappingResponse
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof AmsVidMappingResponse
     */
    vid: string;
}

/**
 * Check if a given object implements the AmsVidMappingResponse interface.
 */
export function instanceOfAmsVidMappingResponse(value: object): value is AmsVidMappingResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('vid' in value) || value['vid'] === undefined) return false;
    return true;
}

export function AmsVidMappingResponseFromJSON(json: any): AmsVidMappingResponse {
    return AmsVidMappingResponseFromJSONTyped(json, false);
}

export function AmsVidMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmsVidMappingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'zipCode': json['zipCode'],
        'vid': json['vid'],
    };
}

export function AmsVidMappingResponseToJSON(json: any): AmsVidMappingResponse {
    return AmsVidMappingResponseToJSONTyped(json, false);
}

export function AmsVidMappingResponseToJSONTyped(value?: AmsVidMappingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'zipCode': value['zipCode'],
        'vid': value['vid'],
    };
}

